export default __webpack_public_path__ + "static/media/awar-kurdish-2oVwN9LVIrw-unsplash.d1690c57.jpg";